import { SET_USER_STATE_AFTER_CANCEL, RESET_CANCEL_LINK, SET_CANCEL_LINK_ERRORS, CANCELLING_LINK } from '../../../../types/conversations/plugins'

const cancelLinkInitialState = { cancellingLink: false, errors: {}, userState: '' }

export default function cancelLink(state = cancelLinkInitialState, action) {
  switch (action.type) {
    case SET_USER_STATE_AFTER_CANCEL: {
      const { userState } = action
      return Object.assign({}, state, { userState })
    }
    case SET_CANCEL_LINK_ERRORS: {
      const { errors } = action
      return Object.assign({}, state, { errors })
    }
    case CANCELLING_LINK: {
      const { cancellingLink } = action
      return Object.assign({}, state, { cancellingLink })
    }
    case RESET_CANCEL_LINK: {
      return cancelLinkInitialState
    }
    default: {
      return state
    }
  }
}
